import { Box, Paper, Typography } from "@mui/material";
import { LeadsManagementData } from "../hooks/useLeadsManagementData";
import { BRAND_COLOR } from "../constants";

interface LeadsByBrandChartProps {
  data: LeadsManagementData;
}

export default function LeadsByBrandChart({ data }: LeadsByBrandChartProps) {
  const { aggregations, goToFilteredLeads } = data;

  // Keyed by brand_uid (what the brand filter actually sends to the API),
  // not the display name, so clicking a row navigates to a real filter value.
  const breakdown = aggregations.byBrand
    .map((item) => ({ brandUid: item.brandUid, brand: item.brandName, count: item.count }))
    .sort((a, b) => b.count - a.count);
  const maxCount = Math.max(1, ...breakdown.map((row) => row.count));

  return (
    <Paper variant="outlined" data-tracker="939" sx={{ mt: 2.5, p: "20px 24px", borderRadius: 2 }}>
      <Typography sx={{ fontSize: 18, fontWeight: 500, color: "#1a1a1a", mb: 2.25 }}>
        Leads by Brand
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.75 }}>
        {breakdown.map((row) => (
          <Box
            key={row.brandUid}
            onClick={() => goToFilteredLeads({ brand: row.brandUid })}
            title="View these leads"
            sx={{ display: "flex", alignItems: "center", gap: 1.5, cursor: "pointer" }}
          >
            <Typography sx={{ width: 150, fontSize: 12.5, color: "#616161", textAlign: "right", lineHeight: 1.2 }}>
              {row.brand}
            </Typography>
            <Box sx={{ flex: 1, bgcolor: "#f3f3f5", borderRadius: 1.5, height: 22, position: "relative", overflow: "hidden" }}>
              <Box
                sx={{
                  height: "100%",
                  borderRadius: 1.5,
                  bgcolor: BRAND_COLOR,
                  width: `${Math.round((row.count / maxCount) * 100)}%`,
                }}
              />
            </Box>
            <Typography sx={{ width: 28, fontSize: 13, fontWeight: 700, color: "#424242" }}>
              {row.count}
            </Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
}
